import React, { Component, PropTypes } from 'react';
import { RaisedButton, TextField, Paper } from 'material-ui';
import { Validation, fieldValidatorCore } from 'react-validation-framework';
import validator from 'validator';
import { css } from 'aphrodite';
import { Link, Redirect } from 'react-router-dom';
import { getValueFromChangeEvent, changeCallbackCaller } from '../../utils';
import styles from './auth-style';

export default class Login extends Component {
  static propTypes = {
    authError: PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
    }),
    auth: PropTypes.shape({
      uid: PropTypes.string,
    }),
    firebase: PropTypes.objectOf(PropTypes.func).isRequired,
  }

  static defaultProps = {
    auth: null,
    authError: null,
  }

  state = {
    email: '',
    password: '',
  }

  componentWillMount() {
    fieldValidatorCore.addSupport('TextField', getValueFromChangeEvent, changeCallbackCaller, 'errorText');
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleLogin = () => {
    if (!this.isValid()) return false;
    const { firebase: { login } } = this.props;
    const { email, password } = this.state;
    return login({ email, password });
  }

  handleKeyDown = e => e.key === 'Enter' && this.handleLogin()

  isValid = () => fieldValidatorCore.checkGroup('login').isValid;

  render() {
    const { authError, auth } = this.props;
    const { email, password } = this.state;

    if (auth) {
      return <Redirect to={{ pathname: '/' }} />;
    }

    return (
      <div className={css(styles.page)}>
        {authError &&
          <span className={css(styles.authError)}>
            {authError.message}
          </span>
        }
        <Paper className={css(styles.paper)}>
          <h1 className={css(styles.header)}>Login</h1>

          <Validation
            group="login"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Email is required',
            }, {
              validator: val => validator.isEmail(val),
              errorMessage: 'Email must be valid',
            }]}
          >
            <TextField
              fullWidth
              required
              floatingLabelText="Email"
              name="email"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={css(styles.textField)}
              type="email"
              value={email}
            />
          </Validation>

          <Validation
            group="login"
            validators={[{
              validator: val => !validator.isEmpty(val),
              errorMessage: 'Password is required',
            }]}
          >
            <TextField
              fullWidth
              required
              floatingLabelText="Password"
              name="password"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              className={css(styles.textField)}
              type="password"
              value={password}
            />
          </Validation>

          <RaisedButton
            fullWidth
            label="Login"
            className={css(styles.btn)}
            onClick={this.handleLogin}
          />

          <Link to="/forgot" className={css([styles.link, styles.forgot])}>Can&#39;t Login?</Link>

        </Paper>
        <Link to="/signup" className={css([styles.link, styles.create])}>Create Account</Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/login.js